import * as Constants from '../actions/constants'
const initial_state = {
    list: null,
}

export const udc = (state = initial_state, action) => {
    switch (action.type) {
        case Constants.GET_UDC_REQUEST:
            return {
                ...state
            }
        case Constants.GET_UDC_SUCCESS:
            console.log("UDC data received:", action.payload);
            return {
                ...state,
                list: action.payload,
            }
        case Constants.GET_UDC_FAILURE:
            return {
                ...state,
            }
        default:
            return state;
    }
}



